import { FC } from 'react';
import { capitalize } from 'src/functions/functions';
import useKeyPress from 'src/hooks/events/useKeyPress';
import Flex from 'src/styles/layouts/Flex';
import { EFlex } from 'src/styles/layouts/Flex/Flex.enum';
import { EIcon } from 'src/styles/theme/components/NGIcon/NGIcon.enum';
import { EDirection, ESize, ETextColor } from 'src/styles/theme/utils/enums';
import { EHotkeysMap } from './HotkeyTooltip.enum';
import { NGIconEx, NGTooltipEx, StyledHotkey, StyledText, StyledWrapper } from './HotkeyTooltip.styles';
import { IHotkeyTooltip, ITooltip, THotkeyPress } from './HotkeyTooltip.type';

const HotkeyTooltip: FC<IHotkeyTooltip> = (props) => {
	const { onHotkeyPress, ...otherProps } = props;
	const { hotkeys, disabled, inactive = false } = otherProps;

	return (
		<>
			{!disabled && onHotkeyPress && hotkeys ? (
				<HotkeyPress hotkeys={hotkeys} onHotkeyPress={onHotkeyPress} inactive={inactive}>
					<Tooltip {...otherProps} />
				</HotkeyPress>
			) : (
				<Tooltip {...otherProps} />
			)}
		</>
	);
};

const HotkeyPress: FC<THotkeyPress> = ({ hotkeys, onHotkeyPress, inactive, children }) => {
	const mappedHotkeys = hotkeys.map((hotkey) => (EHotkeysMap as Record<string, string>)[hotkey] || hotkey);
	useKeyPress(mappedHotkeys, onHotkeyPress, inactive);

	return <>{children}</>;
};

const Tooltip: FC<ITooltip> = ({ hotkeys, direction, text, disabled, inactive, forceHide, children }) => (
	<NGTooltipEx
		isDisabled={disabled}
		inactive={inactive}
		forceHide={forceHide}
		content={
			<Flex gap={ESize['4xs']} vertical={EFlex.center} paddingX={ESize['5xs']}>
				{text && <StyledText>{capitalize(text)}</StyledText>}

				{hotkeys && hotkeys.map((key, index) => <StyledHotkey key={`${key}-${index}`}>{capitalize(key)}</StyledHotkey>)}

				{direction && (
					<StyledHotkey>
						<NGIconEx
							type={direction === EDirection.left ? EIcon.arrowLeft : EIcon.arrowRight}
							color={ETextColor.grey}
							size={ESize.xs}
						/>
					</StyledHotkey>
				)}
			</Flex>
		}
	>
		<StyledWrapper>{children}</StyledWrapper>
	</NGTooltipEx>
);

export { HotkeyTooltip };
